<template>
    <div style="height: 100vh;width: 100vw;">
      <div id="amapcontainer"></div>
    </div>
  </template>
  
  <script>
  // import AMapLoader from '@amap/amap-jsapi-loader';
//   window._AMapSecurityConfig = {
//   securityJsCode: 'ce71898162ea5968d2ad58a4acde97c9' // '「申请的安全密钥」',
// }
  export default {
    data() {
      return {
        map:{},
        mouseTool:{},
        path : [
        new AMap.LngLat(116.368904,39.913423),
        new AMap.LngLat(116.382122,39.901176),
        new AMap.LngLat(116.387271,39.912501),
        new AMap.LngLat(116.398258,39.904600)
        ]
      }
    },
    created(){
     
    },
    mounted() {
     this.initAMap()
    },
    methods: {
     
      initAMap () {
        this. map = new AMap.Map('amapcontainer', {
                zoom: 13,//级别 3-17  越大显示越细节
                 center: [114.305393, 30.593099],//中心点坐标
                // center: [116.397428, 39.90923],  //设置地图中心点坐标
   
                // viewMode: '2D'//使用3D视图
           });
        //实时路况图层
      	var trafficLayer = new AMap.TileLayer.Traffic({
             zIndex: 10
        });
        this.map.add(trafficLayer);//添加图层到地图
        var Polygon = new AMap.Polygon({
            path: this.path,  
            fillColor: '#fff', // 多边形填充颜色
            borderWeight: 2, // 线条宽度，默认为 1
            strokeColor: 'red', // 线条颜色
        });
        this. map.add(Polygon);

    
        const marker = new AMap.Marker({
        position: new AMap.LngLat(116.39,39.9),
        offset: new AMap.Pixel(-10, -10),
         icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_rs.png', // 添加 Icon 图标 URL
       
        title: '北京'
        });
        this. map.add(marker);

    },
    drawRectangle () {
      const vm = this;
      this.mouseTool = new AMap.MouseTool(this.map);
      const polygon = this.mouseTool.polygon({
        strokeColor: 'red',
        strokeOpacity: 0.5,
        strokeWeight: 6,
        fillColor: 'blue',
        fillOpacity: 0.5,
        // strokeStyle还支持 solid
        strokeStyle: 'solid',
        // strokeDasharray: [30,10],
      });
      vm.editRectangle(vm.path);
       
      
    },

    }
  }
</script>
<style  scoped>

#amapcontainer {
  width: 100%;
  height: 1000px;
}

</style>